@switch (journeyStep) {
	@case (JourneyStep.PLAY_ACTIVITY) {
		@if (activity) {
			<app-player-header
				[back]="back"
				[activity]="activity"
				[enableNext]="enableNext"
				(up)="up.emit()"
				(info)="info.emit()"
				(next)="next.emit()"
			></app-player-header>
			@if (showInstructionsPopup) {
				<div class="instructions-click-catcher" (click)="hideInstructions()"></div>
			}
			@if (showInstructionsPopup) {
				<app-header-instructions (onClose)="hideInstructions()" [activity]="activity"></app-header-instructions>
			}
		}
	}
	@default {
		<app-page-header
			[back]="back"
			[useOnBack]="useOnBack"
			[useWindowBack]="useWindowBack"
			(onBack)="onBack.emit()"
		></app-page-header>
	}
}
